<template>
  <div class="container">
    <BaseFrame
      saveText="保存"
      submitText='提交'
      @save='save(2)'
      @submit='save(1)'
      @clear="cancelClick"
      clearText=''
      :isShowBtn='able ? true :false'
    >
      <div slot="content">
        <lk-form :model="promotionForm" label-position="right" :label-width="80" :rules="ruleValidate" ref="promotionForm">
          <div class="cardContainer">
            <lk-card title="活动信息">
               <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="活动类型:">
                   <span>{{ able ? promotionTypeName : promotionForm.promoteTypeName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="活动门店:">
                    <span>{{ pageType === 1 ? promotionStores.name || '-' : promotionForm.storeName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="活动范围:">
                     <lk-select clearable v-model.trim="promotionForm.type" :disabled='promoteType == 1' v-if="able" @on-change="handlerChangeType">
                      <lk-option v-for="item in promotionTypes" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{promotionForm.activityTypeName}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="活动名称:" prop="name">
                    <lk-input :maxlength='20' placeholder='请输入' clearable v-model.trim="promotionForm.name" v-if="able"></lk-input>
                    <span v-else>{{promotionForm.name}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="统计类型:" prop="statisticalType">
                    <lk-select clearable v-model.trim="promotionForm.statisticalType" v-if="able">
                      <lk-option v-for="item in statisticalTypes" :key="item.id" :value="item.id">
                        {{item.title}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{statisticalTypeName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="起止时间:" prop='activeTime'>
                    <timeStampDatePicker style="width:100%"
                      v-if="able"
                      type='daterange'
                      v-model="promotionForm.activeTime"
                      :options='activeTimeDisable'
                      @on-change='dateChange'
                    ></timeStampDatePicker>
                    <span v-else>
                      <span>{{promotionForm.timeBegin | formatDate}}</span> ~ <span>{{promotionForm.timeEnd | formatDate}}</span>
                    </span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                 <lk-col span="7">
                  <lk-form-item label="管理类型:" prop="managementType">
                    <lk-select clearable v-model.trim="promotionForm.managementType" v-if="able">
                      <lk-option v-for="item in managementTypeList" :key="item.id" :value="item.managementType">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                    <span v-else>{{managementTypeName}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <lk-card  title="活动详情">
            <div class="promotionDetail">
              <!-- 条件商品 -->
              <AddPromotionGoods
                v-model="goodsFormalList"
                ref="AddPromotionGoods"
                :storeId='storeId'
                :able='able'
              ></AddPromotionGoods>
              <!-- 条件商品结束 -->
              <!-- 促销商品 -->
                <AddPromotionGoods
                  v-model="goodsGiveList"
                  :storeId='storeId'
                  :isPromotion='true'
                  :able='able'
                  :isShow='isShow'
                ></AddPromotionGoods>
              <!-- 促销商品结束 -->
              <ActiveRules
                v-model="activeRules"
                :goodsFormalList='goodsFormalList'
                :goodsGiveList='goodsGiveList'
                :rebateNote='promotionForm.rebateNote'
                :promoteType='promoteType'
                @addRebateNote='addRebateNote'
                :able='able'
              ></ActiveRules>
            </div>
          </lk-card>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import moment from 'moment';
import InputSearch from '@/components/InputSearch.vue';
import utils from '@/libs/utils';
import service from '@/services/system';
import marketing from '@/services/marketing';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import AddPromotionGoods from '../../../components/marketing/addPromotionGoods.vue';
import ActiveRules from '../../../components/marketing/activeRules.vue';
import sharedDara from '../../../libs/sharedDara';

export default {
  name: 'promotionNew',
  components: {
    BaseFrame,
    ActiveRules,
    AddPromotionGoods,
  },
  computed: {
    promotionTypeName() {
      return this.$route.params.promoteType == 1 ? '商品促销' : '买减/买折';
    },
    managementTypeName() {
      return this.promotionForm.managementType
        ? sharedDara.managementTypeList.find(item => item.managementType === this.promotionForm.managementType).name
        : '';
    },
    able() { // 详情页为false
      return this.pageType != 3;
    },
    statisticalTypeName() {
      return this.promotionForm.statisticalType ? this.statisticalTypes[this.promotionForm.statisticalType - 1].title : '';
    },
    isShow() {
      return this.pageType == 1 ? this.$route.params.promoteType == 1 : this.promotionForm.promoteType == 1;
    },
    storeId() {
      return this.pageType == 1 ? this.$route.params.storeId : this.promotionForm.storeId;
    },
    promoteType() {
      return this.pageType == 1 ? this.$route.params.promoteType : this.promotionForm.promoteType;
    },
    // 仅当活动范围为“线下”时，才可以选择满足条件可选参加
    managementTypeList() {
      return this.promotionForm.type === 1 ? sharedDara.managementTypeList : this.managementTypes;
    },
  },

  watch: {},
  data() {
    return {
      activeTimeDisable: {
        disabledDate(time) {
          if (time) {
            return utils.forbiddenDate.disabledToToday(time);
          }
        },
      },
      promotionTypes: [
        {
          name: '线下',
          promotionType: 1,
          id: 1,
        },
        {
          name: '线上',
          promotionType: 2,
          id: 2,
        },
        {
          name: '全部',
          promotionType: 3,
          id: 3,
        },
      ],
      managementTypes: [
        {
          id: 1,
          managementType: 1,
          name: '满足条件时必须参加',
        },
      ],
      promotionForm: {
        storeId: '',
        name: '',
        promoteType: '',
        type: 1,
        managementType: '',
      },
      statisticalTypes: [
        {
          "title": '票折结算',
          "id": 1,
        },
        {
          "title": '自负成本',
          "id": 2,
        },
      ],
      ruleValidate: {
        statisticalType: [
          {
            required: true, message: '请选择统计类型', trigger: 'change', type: 'number',
          },
        ],
        managementType: [
          {
            required: true, message: '请选择管理类型', trigger: 'change', type: 'number',
          },
        ],
        name: [
          {
            required: true, message: '请输入活动名称', trigger: 'blur', type: 'string',
          },
        ],
        activeTime: [
          {
            required: true, message: '请选择起止时间', trigger: 'change', type: 'array',
          },
        ],
      },
      activeRules: [ // 默认一次性和按固定金额减免
        {
          countRule: 2,
          discountRule: this.promoteType == 1 ? 4 : 1,
        },
      ],
      pageType: 1, // 1新建 2编辑 3详情
      pageTypes: {
        promotionNew: 1,
        promotionEdit: 2,
        promotionDetail: 3,
      },
      promotionStores: {},
      goodsGiveList: [],
      goodsFormalList: [],
      goodsData: [],
      val: '',
    };
  },
  methods: {
    addRebateNote(val) {
      this.promotionForm.rebateNote = val;
    },
    handlerChangeType() {
      this.$refs.AddPromotionGoods.activeTypeChange(this.promotionForm.type);
      this.promotionForm.managementType = null;
    },
    dateChange() {
      if (this.promotionForm.activeTime) {
        let startDay = this.promotionForm.activeTime[0];
        let endDay = this.promotionForm.activeTime[1];
        this.promotionForm.activeTime[0] = moment(startDay).startOf('day').valueOf()
        this.promotionForm.activeTime[1] = moment(endDay).endOf('day').valueOf();
      }
    },
    cancelClick() {
      this.$router.go(-1);
    },
    goodsValidate() {
      if (this.goodsFormalList.length === 0) {
        this.$Message.warning('无法提交，请至少添加一个条件商品');
        return true;
      }
      if (this.goodsGiveList.length === 0 && this.promoteType == 1) {
        this.$Message.warning('无法提交，请至少添加一个促销商品');
        return true;
      }
      const flag = this.goodsFormalList.some(item => !item.batchSeqs || item.batchSeqs.length === 0);
      if (flag) {
        this.$Message.warning('无法提交，请选择条件商品批次');
        return true;
      }
      const flag1 = this.goodsGiveList.some(item => !item.batchSeqs || item.batchSeqs.length === 0);
      if (flag1 && this.promoteType == 1) {
        this.$Message.warning('无法提交，请选择促销商品批次');
        return true;
      }
      const result = this.activeRules.reduce((pre, item) => {
        const condition1 = (item.countRule === 1 || 3)
                            && item.discountNum
                            && item.goodsNum;
        const condition2 = item.countRule === 2
                            && item.discountNum
                            && item.goodsNum;
        return (condition1 || condition2) && pre;
      }, true);
      if (!result) {
        this.$Message.warning('无法提交，请完善活动规则');
      }
      return !result;
    },
    getStores() {
      if (this.pageType == 1) {
        service.getBelongStores().then((res) => {
          this.promotionStores = {};
          if (res.data.status === 200) {
            const { storeId } = this.$route.params
            if (storeId == 0) {
              this.promotionStores = {
                name: '全部门店',
                id: 0,
              }
            } else {
              this.promotionStores = res.data.data.filter(item => item.id == storeId)[0];
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    /**
     * saveType 1提交 2保存
     */
    save(saveType) {
      this.$refs.promotionForm.validate((valid) => {
        if (valid) {
          if (!this.goodsValidate()) {
            let temp = {};
            let promoteSales = this.promotionForm;
            promoteSales.timeBegin = this.promotionForm.activeTime[0];
            promoteSales.timeEnd = this.promotionForm.activeTime[1];
            let salesGoodsList = [];
            this.goodsFormalList.forEach(item => {
              const obj = {
                "goodsBaseId": item.goodsBaseId,
                "goodsStoreId": item.goodsStoreId,
                "serialCode": item.drugSerialCode || item.serialCode,
                "batchCode": item.goodsBatchNumber  || item.batchCode,
                "batchSeq": item.batchSeqs[0]=='全部批次' ? '' : item.batchSeqs.join(','),
                "minPkgUnit": item.drugMiniPackageUnitCode || item.minPkgUnit,
                "isPromote": 0,
              }
              salesGoodsList.push(obj);
            })
            this.goodsGiveList.forEach(item => {
              const obj = {
                "goodsBaseId": item.goodsBaseId,
                "goodsStoreId": item.goodsStoreId,
                "serialCode": item.drugSerialCode || item.serialCode,
                "batchCode": item.goodsBatchNumber || item.batchCode,
                "batchSeq": item.batchSeqs[0]== '全部批次' ? '' : item.batchSeqs.join(','),
                "minPkgUnit": item.drugMiniPackageUnitCode || item.minPkgUnit,
                "isPromote": 1,
              }
              salesGoodsList.push(obj);
            })
            temp.promoteSalesGoodsFormalList = salesGoodsList;
            temp.promoteRuleList = this.activeRules;
            if (this.pageType == 1) {
              promoteSales.promoteType = this.$route.params.promoteType;
              promoteSales.storeId = this.promotionStores.id;
              promoteSales.storeName = this.promotionStores.name;
            }
            temp.promoteSales = promoteSales;
            const saveFunc = saveType === 1 ? marketing.promoteSubmit : marketing.promoteSave;
            saveFunc(temp).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success(saveType === 1 ? '提交成功' : '保存成功');
                this.$router.push({ name: 'promotionList' });
              } else {
                this.$Message.warning(res.data.error);
              }
            });
          }
        } else {
          this.$Message.warning('请输入必填项');
        }
      });
    },
    initData() {
      if (this.pageType !== 1) {
        // 详情获取接口 获取详情
        marketing.getPromoteInfo({ promoteId: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            const result = res.data.data;
            this.promotionForm = result.promoteSales;
            if (this.pageType === 2) {
              this.$refs.AddPromotionGoods.activeTypeChange(result.promoteSales.type);
            }
            this.promotionForm.storeId = result.promoteSales.storeId || 0; // 全部门店storeId为0
            this.$set(this.promotionForm, 'activeTime', [result.promoteSales.timeBegin, result.promoteSales.timeEnd]);
            let goodsGiveList = [];
            let goodsFormalList = [];
            let salesGoodsList = utils.deepClone(result.salesGoodsList);
            salesGoodsList.forEach(item => {
              item.dosageForm = item.dosageFormName;
              item.drugSerialCode = item.serialCode;
              item.drugMiniPackageUnit = item.minPkgUnitName;
              item.batchSeqList = item.batchSeq.split(",");
              item.isPromote ? goodsGiveList.push(item) : goodsFormalList.push(item);
            })
            this.goodsGiveList = goodsGiveList;
            this.goodsFormalList = goodsFormalList;
            this.activeRules = result.promoteRuleList;
          }
        });
      }
    },
  },
  mounted() {
    this.pageType = this.pageTypes[this.$route.name];
    this.getStores();
    this.initData();
  },
};
</script>
<style lang="less">
  .cardContainer {
    margin-bottom: 16px;
  }
  .promotionDetail {
    padding: 0 16px;
  }
  .steps-wrap{
    padding-top: 30px;
    padding: 30px;
  }
  .queryCon {
    display: flex;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      >label{
        padding-right: 8px
      }
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  .p-font{
    padding: 0 10px;
    margin-bottom: 10px;
  }
  .card-margin {
    margin-top: 10px;
    .active-rules {
      display: flex;
      flex-direction: column;
      .rules-content {
        display: flex;
        margin-bottom: 20px;
        .rebateNote {
          padding-top: 12px;
        }
      }
    }
    .rules-left {
      width: 80px;
      padding-top: 12px;
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
      .btn-item {
        margin-right: 20px;
      }
    }
    .labelTitle:before{
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 12px;
      color: #ed4014;
    }
  }
  .backGroundCard{
    background: linear-gradient(180deg, #f5f5f5 0, #f5f5f5 calc(~'100% - 8px'),#fff calc(~'100% - 7px'));
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .rules-right {
    display: flex;
    flex-direction: column;
    .rules-right-contantCheck {
       padding: 12px 4px !important;
    }
    .rules-right-contant {
      display: flex;
      align-items: center;
      padding: 6px 4px;
      .rules-item {
        display: flex;
        align-items: center;
        .num-input {
          width: 90px;
          margin: 0 4px;
        }
        .num-sapn {
          width: auto;
          margin: 0 6px;
        }
        .rules-span {
          width: auto;
          margin: 0 6px;
        }
        .active-span {
          width: auto;
          margin: 0 6px;
        }
      }
      .maxNumContent {
        display: flex;
        align-items: center;
      }
      .deleteOne {
        width: 40px;
        margin-left: 8px;
      }
    }
    .addOne {
      width: 40px;
    }
    .addCon {
      margin-top: 4px;
      color: #2d8cf0;
    }
  }
</style>
